export const SENSITIVE_TERMS_TYPE = { SENSITIVE_PRIVACY_POLICY: 'SENSITIVE_PRIVACY_POLICY' } as const;

export type sensitiveTermsType = typeof SENSITIVE_TERMS_TYPE[keyof typeof SENSITIVE_TERMS_TYPE];
